import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MeasureController from 'core/analytics/MeasureController'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { changeRTM, selectQBRRtm } from 'partner360/features/QBR'

import { QBRDocumentsTable } from './components/qbrDocumentsTable/QBRDocumentsTable'
import { QbrLinkButtons } from './components/qbrLinkButtons/QbrLinkButtons'
import { QbrPartnerTypeButtons } from './components/qbrPartnerTypeButtons/QbrPartnerTypeButtons'

import styles from './QBRDocumentsList.module.scss'

interface IQBRDocumentsListProps {
  metrics: MeasureController
  onCreateNewDocument: () => void
  openDocumentDetail: (documentId: number, isLegacyDocument: boolean) => void
  openQbrDocumentUploadDialog: () => void
}

export const QBRDocumentsList = ({
  metrics,
  onCreateNewDocument,
  openDocumentDetail,
  openQbrDocumentUploadDialog,
}: IQBRDocumentsListProps) => {
  const dispatch = useDispatch()

  const qbrRtm = useSelector(selectQBRRtm)

  const onOptionClick = useCallback(
    (value: PartnerType) => {
      dispatch(changeRTM(value))
    },
    [dispatch]
  )

  return (
    <div>
      <div className={styles.actionButtons}>
        <QbrPartnerTypeButtons
          translationKeyPrefix={TRANSLATION_KEYS.partnerTypeButtonPrefix}
          value={qbrRtm}
          onOptionClick={onOptionClick}
          buttonClassName={styles.typeButtons}
        />
        <QbrLinkButtons />
      </div>
      <QBRDocumentsTable
        partnerType={qbrRtm}
        metrics={metrics}
        onCreateNewDocument={onCreateNewDocument}
        openQbrDocumentUploadDialog={openQbrDocumentUploadDialog}
        openDocumentDetail={openDocumentDetail}
      />
    </div>
  )
}
